export default __webpack_public_path__ + "static/media/webImage.5f069dcd.jpg";